import React from 'react';
import { isAdmin, useProfileCourses } from '../../../hooks';
import { IBLSpinLoader, UserCoursesBox } from '../../../components';
import './CourseViewContent.css';
import { NoItemView } from '../../../components/NoItemView';
import _ from 'lodash';
import { inIframe } from '../../../utils';
import { useTranslation } from 'react-i18next';

export const CourseViewContent = ({ username }) => {
  const [coursesData, courseDataLoaded] = useProfileCourses(username);
  const { t } = useTranslation('library');

  return (
    <span>
      <div
        className="ov_panel active"
        data-name="cs"
        style={{ marginTop: '20px' }}
      >
        <div className="br_cont">
          <div className="div-block-483">
            <div className="text-block-278">{t('Courses in Progress')}</div>
          </div>
          {courseDataLoaded ? (
            _.isEmpty(coursesData) && inIframe() ? (
              <NoItemView
                displayMessage={
                  inIframe()
                    ? `${username} ${t(
                        "doesn't have any courses in progress yet."
                      )}`
                    : t("You don't have any courses in progress yet.")
                }
                displayPadding={true}
              />
            ) : (
              <div className="br_row">
                <div className="div-block-430 sl pathway_grid">
                  <UserCoursesBox
                    userCourses={coursesData}
                    userCoursesLoaded={courseDataLoaded}
                    username={username}
                  />
                </div>
              </div>
            )
          ) : (
            <IBLSpinLoader size={40} containerHeight={'200px'} />
          )}
        </div>
      </div>
    </span>
  );
};
